module.exports = __webpack_public_path__ + "img/nav-m-1.c0ca3635.png";